
import FormInput from '@/components/FormInput/FormInput.vue'
import IconAction from '@/components/IconAction/IconAction.vue'
import SelectPicker from '@/components/SelectPicker/SelectPicker.vue'
import ViewModel from '@/models/ViewModel'
import moment from 'moment'

import {
  Component, Prop, Ref, Vue, Watch,
} from 'vue-property-decorator'
import DatePicker from '@/components/DatePicker/DatePicker.vue'
import SelectOption from '@/models/interface/SelectOption'
import Widget from '@/components/Widget/Widget.vue'
import { currencyMask, negativeCurrencyMask } from '@/models/interface/Masks'
import IncrementalRevenue from '@/models/OpportunityAmountChange'
import Opportunity from '@/models/Opportunity'
import { ProductsFull } from '@/models/interface/Common'

@Component({
  components: {
    FormInput,
    DatePicker,
    Widget,
    IconAction,
    SelectPicker,
  },
})
export default class AmountChangeTab extends ViewModel {
  @Ref() public alertRef!: any

  @Prop({ default: '', required: true })
  public target!: string

  @Prop()
  public value!: any

  @Prop()
  public targetValue!: string

  @Prop({ required: true })
  public opportunity!: Opportunity

  // @Watch('local_value', { deep: true })
  // public onLocalValueChange(v: any) {
  //   this.$emit('input', v)
  // }

  public perPage: number = 25

  public currentPage: number = 1

  public sortBy: string = 'created_at'

  public sortDesc: boolean = true

  public filter_mode: string = 'inclusive'

  public records: number = 0

  public temp_revenue: IncrementalRevenue = new IncrementalRevenue()

  public is_creating: boolean = false

  public is_editing: boolean = false

  public local_value: IncrementalRevenue[] = []

  public confirming: boolean = false

  public showDismissibleAlert: boolean = true

  public temp_index: number = 0

  public tooltip_display: boolean = false

  public pagination_options: any = [
    { name: '10', value: '10' },
    { name: '25', value: '25' },
    { name: '50', value: '50' },
    { name: '100', value: '100' },
  ]

  public get records_text(): string {
    if (this.records === 0) {
      return ''
    }
    let start = (this.currentPage - 1) * this.perPage + 1
    let end = this.currentPage * this.perPage
    return `${start} - ${end} of ${this.records}`
  }

  public get masks() {
    return {
      currency: currencyMask,
      negative_currency: negativeCurrencyMask,
    }
  }

  public get options() {
    return {
      products: ProductsFull,
    }
  }

  public mounted() {
    //
    this.temp_revenue.readOpportunity(this.opportunity)
    this.temp_revenue.revenue_details = this.temp_revenue.fresh()
    if (this.opportunity.id && this.opportunity.id.length > 0) {
      this.loadData()
    }
  }

  public parseMonth(month: string) {
    return month.replace('_', ' ')
  }

  public changePage(page: number) {
    this.currentPage = page
    this.loadData()
  }

  public loadData() {
    this.loading = true
    let value = this.targetValue ? this.targetValue : this.opportunity.id
    return IncrementalRevenue.paginate({
      page_size: this.perPage,
      page: this.currentPage,
      order_by: 'closed_at',
      order: 'desc',
      query: [`${this.target}:${value}`],
      mode: this.filter_mode,
    })
      .then(result => {
        /**
         * This is to prevent losing unsaved data, that is saved only when the Opportunity is saved.
         */
        if (this.value.length) {
          this.local_value = result.data
        } else {
          this.local_value = result.data
        }
        this.records = result.records
        this.loading = false
      })
      .catch(() => {
        this.loading = false
      })
  }

  public closeAnimation(cll: any = null, time: number = 500) {
    document.querySelector('.incremental-rev-tab')?.classList.remove('smooth-slide-in-top')
    document.querySelector('.incremental-rev-tab')?.classList.add('smooth-slide-out-top')
    if (cll) {
      setTimeout(() => {
        cll()
      }, time)
    }
  }

  public close() {
    this.closeAnimation(() => {
      this.is_creating = false
      this.is_editing = false
      this.temp_revenue = new IncrementalRevenue()

      window.scrollTo(0, 0)
    })
  }

  public checkAndAlertRemainingValue(clb: any = null) {
    if (this.temp_revenue.remainingValue) {
      this.confirming = true
    } else {
      this.confirming = false
      if (clb) {
        clb()
      }
    }
  }

  public addRevenue(ignore: boolean = false) {
    let exec = () => {
      let copy = this.temp_revenue.apiData

      if (this.temp_revenue.id && this.temp_revenue.id.length) {
        let index = this.local_value.findIndex(l => l.id === this.temp_revenue.id)
        this.local_value[index] = IncrementalRevenue.toObject(copy)
      } else if (this.temp_revenue.temp_id && this.temp_revenue.temp_id.length) {
        // for locally created revenue (not saved yet)
        let index = this.local_value.findIndex(l => l.temp_id === this.temp_revenue.temp_id)
        this.local_value[index] = IncrementalRevenue.toObject(copy)
      } else {
        let x = IncrementalRevenue.toObject(copy)

        if ((!this.temp_revenue.id || !this.temp_revenue.id.length) && !this.temp_revenue.temp_id) {
          x.temp_id = Math.random().toString(36).substring(7)
        }

        this.local_value.push(x)
      }

      this.close()
    }
    if (ignore) {
      this.closeRemainingRevenueAlert()
      exec()
      return
    }
    this.checkAndAlertRemainingValue(exec)
  }

  public editRevenue(rev: IncrementalRevenue) {
    this.temp_revenue = IncrementalRevenue.toObject(JSON.parse(JSON.stringify(rev)))
    this.temp_revenue.readOpportunity(this.opportunity)
    this.is_creating = true
    this.is_editing = true
  }

  public createNew() {
    this.temp_revenue = new IncrementalRevenue()
    this.temp_revenue.readOpportunity(this.opportunity)
    this.temp_revenue.revenue_details = this.temp_revenue.fresh()
    this.is_creating = true
    this.is_editing = false
  }

  public arrayLimit(arr: any[], limit: number) {
    let btw = arr.sort((a, b) => a - b)

    if (arr.length > limit) {
      return [btw[0], btw[btw.length - 1]]
    }
    return arr
  }

  public closeRemainingRevenueAlert() {
    this.alertRef.$el.classList.remove('smooth-slide-in-right')
    this.alertRef.$el.classList.add('smooth-slide-out-top')
    setTimeout(() => {
      this.showDismissibleAlert = false
    }, 100)
    setTimeout(() => {
      this.showDismissibleAlert = true
      this.confirming = false
    }, 400)
  }

  public deleteItem(index: number) {
    this.temp_index = index
    this.tooltip_display = true
  }
}
